/**
 * 接口域名的管理
 */
// 正式配置
// const base = {
//
//   //sq:'/api',//请求代理需要用到
//     sq:'http://wechat.nxptdn.com',
//     bd: 'http://operator.nxptdn.com',
//     client:'http://e.nxptdn.com',
//     appid:'wx65810fb2381de672'
// }


//演示环境 
const base = {
  sq: '/api',//请求代理需要用到
  // bd: 'http://hzgj-h5.huizhidata.com/apipro',
  // bd: 'http://127.0.0.1:8510',
  // bd: '/api',
    bd: '/prod-cloud-api',
   //bd: '/prod-cloud-api',

  client: 'https://h5.charge.fangxincharge.com',
  // client: 'http://192.168.31.148:8080',
}





export default base;


